// extracted by mini-css-extract-plugin
export default {"loginForm":"LoginForm_loginForm__a4w3E","fadeIn":"LoginForm_fadeIn__wW-bX","inputError":"LoginForm_inputError__tpc2u","shake":"LoginForm_shake__wmT5z"};